export default __webpack_public_path__ + "static/media/main_theme.8cda7108.mp3";